export { default as Pills } from './Pills';
